import { useState } from "react";
import api from "../api/api";

export default function Followup() {
  const [followups, setFollowups] = useState([]);

  const [form, setForm] = useState({
    meeting_id: "",
    followup_date: "",
    note: "",
  });

  // LOAD
  const load = async () => {
    try {
      const res = await api.get("/followup");
      setFollowups(res.data || []);
    } catch (err) {
      console.log(err);
      alert("Error loading followups");
    }
  };

  // CREATE
  const create = async () => {
    const { meeting_id, followup_date, note } = form;

    if (!meeting_id || !followup_date || !note) {
      return alert("All fields are mandatory");
    }

    try {
      await api.post("/followup", form);

      alert("Follow-up Created");

      setForm({
        meeting_id: "",
        followup_date: "",
        note: "",
      });

      load();
    } catch (err) {
      console.log(err);
      alert("Error creating follow-up");
    }
  };

  return (
    <div className="min-h-screen -mt-10">
      <h2 className="text-4xl font-semibold text-[#030244] text-center mb-8">
        Follow-up
      </h2>

      {/* FORM */}
      <div className="max-w-md mx-auto bg-white shadow-lg p-8 rounded-xl border">
        <div className="flex flex-col gap-4">
          <input
            className="border p-2 rounded focus:outline-none focus:ring-1 focus:ring-gray-500"
            placeholder="Meeting ID"
            value={form.meeting_id}
            onChange={(e) =>
              setForm({ ...form, meeting_id: e.target.value })
            }
          />

          <input
            type="datetime-local"
            className="border p-2 rounded focus:outline-none focus:ring-1 focus:ring-gray-500"
            value={form.followup_date}
            onChange={(e) =>
              setForm({ ...form, followup_date: e.target.value })
            }
          />

          <input
            className="border p-2 rounded focus:outline-none focus:ring-1 focus:ring-gray-500"
            placeholder="Note"
            value={form.note}
            onChange={(e) =>
              setForm({ ...form, note: e.target.value })
            }
          />
        </div>

        <div className="flex justify-center gap-4 mt-6">
          <button
            onClick={create}
            className="bg-[#030244] hover:bg-[#040261] text-white px-6 py-2 rounded text-lg"
          >
            Create
          </button>

          <button
            onClick={load}
            className="bg-green-700 hover:bg-green-600 text-white px-6 py-2 rounded text-lg"
          >
            Load
          </button>
        </div>
      </div>

      {/* TABLE */}
      <div className="w-full max-w-5xl mx-auto bg-white shadow mt-12 rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[900px]">
          <thead className="bg-[#030244] text-white text-xl">
            <tr>
              <th className="p-3 text-center font-medium border">Follow-up ID</th>
              <th className="p-3 text-center font-medium border">Meeting ID</th>
              <th className="p-3 text-center font-medium border">Note</th>
              <th className="p-3 text-center font-medium border">Date</th>
              <th className="p-3 text-center font-medium border">Status</th>
            </tr>
          </thead>

          <tbody>
            {followups.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center p-4 text-xl">
                  No Data Found
                </td>
              </tr>
            ) : (
              followups.map((f) => (
                <tr key={f.followup_id} className="border-b text-lg">
                  <td className="p-3 text-center border text-gray-700">{f.followup_id}</td>
                  <td className="p-3 text-center border text-gray-700">
                    {f.meeting_id}
                  </td>
                  <td className="p-3 text-center border text-gray-700">
                    {f.note}
                  </td>
                  <td className="p-3 text-center border text-gray-700">
                    {new Date(f.followup_date).toLocaleString()}
                  </td>
                  <td className="p-3 text-center border text-gray-700">
                    <span
                      className={`px-3 py-1 rounded capitalize text-lg text-white ${
                        f.status === "Completed"
                          ? "bg-green-700"
                          : "bg-[#ee600e]"
                      }`}
                    >
                      {f.status}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      </div>
    </div>
  );
}